import type { ProgramFeaturedParticipant } from 'models';
import { Trans } from 'react-i18next';
import { Avatar, Flex, RichTextRenderer } from 'ui';
import { Text } from 'ui/typography';

type P = {
  participants: ProgramFeaturedParticipant[];
};

/**
 * @deprecated This component was only ported to TypeScript as-is as part of #86881, not redesigned. Do not use it as a
 * reference for new code.
 */
const ProgramFeaturedParticipants = ({ participants }: P) => (
  <Flex className="card-wrapper card-wrapper--participants">
    <Flex className="card-content card-content--participants" vertical>
      <Text className="card-content__title">
        <Trans>Featured Participants</Trans>
      </Text>
      {participants.map((participant) => (
        <Flex className="participant-box" key={participant.name}>
          <Flex className="avatar-photo avatar-photo--participants" vertical>
            <Avatar size={72} src={participant.logo} />
          </Flex>
          <Flex className="card-content" vertical>
            <Text className="program-featured-participants__name">{participant.name}</Text>
            <Text className="participant-box__quote">
              <RichTextRenderer data={participant.htmlDescription} />
            </Text>
          </Flex>
        </Flex>
      ))}
    </Flex>
  </Flex>
);

export default ProgramFeaturedParticipants;
